import { Create } from '@fund/api-modules';
import { getApiHostWithoutEnv } from '@fund/api-host';
import CreateByUser from './decorator/CreateByUser';

@CreateByUser({
  getUserParams: (userInfo) => {
    const {
      utoken,
      ctoken,
      uid,
      deviceid,
    } = userInfo;
    return {
      utoken,
      ctoken,
      deviceid,
      version: '6.9.9',
      customerNo: uid,
      mobileKey: deviceid,
      product: 'EFund',
      plat: 'web',
    };
  },
})

@Create({
  baseURL: getApiHostWithoutEnv('push2api'), // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  params: {
    // TODO 接口校验deviceId需要确认
    deviceid: '65508749-27FF-48C1-9D86-AFF388D161B1',
    version: '6.9.9',
    appVersion: '6.9.9',
    product: 'EFund',
    plat: 'web',
  },
  headers: {
    'content-type': 'application/x-www-form-urlencoded',
    validmark: 'xxx',
  },
})

class StokeApi {
  getStokeHQCodelist(FCODE) {
    return this.GET('/api/qt/stock/get', {
      fltt: 2,
      invt: 2,
      secid: FCODE,
      fields: 'f43,f44,f45,f46,f47,f48,f51,f52,f59,f60,f86,f152,f169,f170,f292',
      ut: '94dd9fba6f4581ffc558a7b1a7c2b8a3',
    });
  }

  getETFFundMarket(params = { FCODE: '', wbp2u: '' }) {
    return this.GET('/api/qt/stock/get', {
      fltt: 2,
      invt: 2,
      secid: params.FCODE,
      fields: 'f43,f44,f45,f46,f47,f48,f51,f52,f59,f60,f86,f152,f169,f170,f292',
      ut: '94dd9fba6f4581ffc558a7b1a7c2b8a3',
      wbp2u: params.wbp2u,
    });
  }

  getTimeShareData(params) {
    return this.GET('/api/qt/stock/trends2/get', {
      ...params,
    });
  }

  getIndexData(params) {
    const requestParams = params || {
      fltt: '2',
      secids: '',
      fields: 'f1,f2,f3,f4,f12,f13,f14,f292',
      ut: '94dd9fba6f4581ffc558a7b1a7c2b8a3',
    };
    return this.POST('/api/qt/ulist.np/get', {
      ...requestParams,
    });
  }

  getMarketData(params) {
    const requestParams = params || {
      fltt: '2',
      secids: '',
      fields: 'f1,f2,f3,f4,f12,f13,f14,f292',
      ut: '94dd9fba6f4581ffc558a7b1a7c2b8a3',
    };
    return this.GET('/api/qt/ulist.np/get', {
      ...requestParams,
    });
  }
}
export default new StokeApi();
